export const get = (name) => localStorage.getItem(name);
export const set = (name, value) => localStorage.setItem(name, value);
export const remove = (name) => localStorage.removeItem(name);
